module.exports = __webpack_public_path__ + "assets/img/DS-room1 (1).93aff182.jpg";